(function() {
  'use strict';

angular
  .module('service.survey')
  .factory('SurveyService', SurveyService);

  SurveyService.$inject = ['$http', 'ServiceHelper'];

  function SurveyService($http, ServiceHelper) {
    var url = {
      survey: 'https://:host/:ipad/gaviota-api/trainee/cModule/:cModuleId/course/:courseId/survey/:surveyId/question/:questionId'
    };

    var keys = ['ipad', 'cModuleId', 'courseId', 'surveyId', 'questionId'];

    function createUrl(baseUrl, data) {
      return keys.reduce(function(url, key) {
        return url.replace(new RegExp('/:' + key), '');
      }, Object.keys(data).reduce(function(url, key) {
        var value = data[key]
        return url.replace(new RegExp('/:' + key), value ? '/' + data[key] : '');
      }, baseUrl));
    }

    function respond(promise, resultCb, errorCb) {
      return promise.then(function(response) {
        resultCb = resultCb || angular.noop;
        return resultCb(response.data);
      }, function(response) {
        return ServiceHelper.errorHandler(errorCb || angular.noop)(response);
      });
    }

    var service = {
      answerQuestion: answerQuestion
    };

    return service;

    function answerQuestion(params, resultCb, errorCb) {
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: params.cModuleId,
        courseId: params.courseId,
        surveyId: params.surveyId,
        questionId: params.questionId
      });

      return ServiceHelper.checkCanCallService(function () {
        return respond($http.post(createUrl(url.survey, urlParams), params),
          resultCb, errorCb);
      });
    }
  }
})();
